import TooltipManagerHtml from "./TooltipManagerHtml.js";

export default class TooltipManagerCmp{
    #html = new TooltipManagerHtml();

    /** @param {HTMLElement} parent */
    init(parent){
        this.#html.init(parent);
        this.#html.onClose(this.#onClose.bind(this));
        this.#startManaging()
    }

    #startManaging(){
        const value = this.#getValueFromLocalStorage();
        if (value){
            const storedDate = value.data.nextDate;
            if (storedDate) {
                const futureDate = new Date(storedDate);
                const now = new Date();
                if (now >= futureDate) {
                    this.#showTooltip(value)
                }
            }
        } else {
            const tooltipData = this.#getTooltipData(TooltipManagerCmp.#tooltipNames.first);
            // Only if we don't have any value in storage we want to show tooltip after 1 minute
            const newDate = new Date();
            newDate.setMinutes(newDate.getMinutes() + 1);
            tooltipData.data.nextDate = newDate;
            this.#saveDataInStorage(tooltipData);
        }
    }

    /**
     * @param {{name: string, data: {tooltipText: string, nextDate: Date}}} tooltipData
     */
    #onClose(tooltipData){
        const newDataName = tooltipData.name === TooltipManagerCmp.#tooltipNames.first
            ? TooltipManagerCmp.#tooltipNames.second : TooltipManagerCmp.#tooltipNames.first;
        const newData = this.#getTooltipData(newDataName);
        this.#saveDataInStorage(newData);
    }

    /**
     * @returns {{name: string, data: {tooltipText: string, nextDate: Date}}|null}
     */
    #getValueFromLocalStorage(){
        const value = window.localStorage.getItem(TooltipManagerCmp.#keyName);
        if (value && value.length)
            return JSON.parse(value);
        return null;
    }

    /**
     * @param {{name: string, data: {tooltipText: string, nextDate: Date}}} tooltipData
     */
    #showTooltip(tooltipData){
        this.#html.show(tooltipData);
    }

    /**
     * @param {{name: string, data: {tooltipText: string, nextDate: Date}}} tooltipData
     */
    #saveDataInStorage(tooltipData){
        window.localStorage.setItem(TooltipManagerCmp.#keyName, JSON.stringify(tooltipData))
    }

    #getDateAfterNow(days){
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + days);
        return futureDate;
    }

    /**
     * @param name
     * @returns {{name: string, data: {tooltipText: string, nextDate: Date}}}
     */
    #getTooltipData(name){
        switch (name){
            case TooltipManagerCmp.#tooltipNames.first: {
                return {
                    name: TooltipManagerCmp.#tooltipNames.first, data:
                        {
                            tooltipText: TooltipManagerCmp.#firstTooltip,
                            nextDate: this.#getDateAfterNow(29)
                        }
                }
            }
            case TooltipManagerCmp.#tooltipNames.second: {
                return {
                    name: TooltipManagerCmp.#tooltipNames.second, data:
                        {
                            tooltipText: TooltipManagerCmp.#secondTooltip,
                            nextDate: this.#getDateAfterNow(1)
                        }
                }
            }
            default: {
                return {
                    name: TooltipManagerCmp.#tooltipNames.first, data:
                        {
                            tooltipText: TooltipManagerCmp.#firstTooltip,
                            nextDate: this.#getDateAfterNow(1)
                        }
                }
            }
        }
    }

    static #keyName = "meve-tooltip";
    static #tooltipNames = {
        first: "first",
        second: "second"
    }
    static #firstTooltip = "Want your private instance with your own data? Reach out: collab@elsci.io"
    static #secondTooltip = "Want to add another public data source? Reach out: collab@elsci.io"
}